import React from 'react'
function SmartCollect() {
return (
<div class="idocs-content">
   <div class="container">
      <div class="row">
         <div class="col-md-8">
            <section id="idocs_changelog1">
               <h1>Smart Collect</h1>
               <hr/>
               <p>
                  Smart Collect is a new feature of the Safexpay payment gateway system that offers enhanced payment collection capabilities to merchants.
               </p>
               <h5>
                  Key Features: 
               </h5>
               <ul>
                  <li><b>Multiple payment options:</b> Smart Collect supports multiple payment options, including credit cards, debit cards, net banking, and UPI, providing flexibility and convenience for customers.</li>
                  <li><b>Customizable payment page:</b> Smart Collect offers a customizable payment page, which can be branded with the merchant's logo, color scheme, and other design elements, to provide professional and branded payment experience for customers.</li>
                  <li><b>Recurring payments:</b> Smart Collect allows merchants to set up recurring payments for subscription-based services, reducing administrative overheads and improving cash flow.</li>
                  <li><b>Batch payments:</b> Smart Collect supports batch payments, enabling merchants to process multiple payments in a single transaction, reducing processing time and improving efficiency.</li>
                  <li><b>API integration:</b> Smart Collect offers API integration with merchant websites or apps, enabling a seamless and automated payment experience for customers.</li>
                  <li><b>Comprehensive reporting:</b> Smart Collect offers comprehensive reporting and analytics, enabling merchants to track and manage payment activity and gain insights into customer behavior.</li>
               </ul>
               <p>
                  Smart Collect is a powerful tool for merchants to manage payment collections, reduce administrative overheads, and create professional payment experience for customers. By offering a customizable, secure, and automated payment solution, merchants can improve payment collections, streamline payment processing, and gain valuable insights into customer behavior, which can help drive business growth and success.
               </p>
            </section>
         </div>
         <div class="col-md-4">
         </div>
      </div>
   </div>
</div>
)
}
export default SmartCollect